import { FormInput } from '@policoders/ds';
import PageHeader from '@shared/components/page-header';

import { useUserProfile } from './user-profile.hook';

export const UserProfilePage = () => {
  const { state, handleChange, handleSave } = useUserProfile();

  return (
    <>
      <PageHeader title="Perfil do usuário" actions={[{ title: 'Salvar', onClick: handleSave }]} />

      <div className="row">
        <div className="col-12 col-lg-5">
          <FormInput
            label="Nome completo"
            field="name"
            type="text"
            value={state.name}
            onChange={handleChange}
          />
        </div>

        <div className="col col-lg-3">
          <FormInput
            label="Telefone"
            field="telephone"
            type="tel"
            placeholder="(xx) 0000-0000"
            value={state.telephone}
            onChange={handleChange}
          />
        </div>

        <div className="col col-lg-4">
          <FormInput
            label="E-mail"
            field="email"
            type="email"
            placeholder="name@example.com"
            disabled={true}
            value={state.email}
          />
        </div>
      </div>
    </>
  );
};
